import { render, staticRenderFns } from "./DriversConfig.vue?vue&type=template&id=4a87a8f1&scoped=true&"
import script from "./DriversConfig.vue?vue&type=script&lang=js&"
export * from "./DriversConfig.vue?vue&type=script&lang=js&"
import style0 from "./DriversConfig.vue?vue&type=style&index=0&id=4a87a8f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87a8f1",
  null
  
)

export default component.exports